import React, { useEffect, useState } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsGetAll } from 'services/WService';

export default function ModalSeller(props) {
  const docSerie = props.model;

  const [docSeries, setDocSeries] = useState([]);

  async function listDocSeries() {
    let response = await wsGetAll(`sap/syp-numdoc?Code=${props.idDocumentP}`);
    if (response.success) setDocSeries(response.data);
  }

  useEffect(() => {
    if (docSerie.open) {
      listDocSeries();
    }
  }, [docSerie.open]);

  return (
    <Modal
      title="Permiso documento"
      model={docSerie}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataForce={{
        oauth_user_id: props.idUser,
        document: props.idDocumentP
      }}
      entity="prt/document-serie-permission"
    >
      <FormControl fullWidth margin="normal" size="small" required>
        <InputLabel>Serie</InputLabel>
        <Select
          defaultValue={docSerie.serie || ''}
          inputProps={{
            name: 'serie'
          }}
        >
          {docSeries.map((item, i) => {
            return (
              <MenuItem key={i} value={item.U_SYP_NDSD}>
                {item.U_SYP_NDSD}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Activo</InputLabel>
        <Select
          defaultValue={docSerie.active || 'Y'}
          inputProps={{
            name: 'active'
          }}
        >
          <MenuItem value="Y">Si</MenuItem>
          <MenuItem value="N">No</MenuItem>
        </Select>
      </FormControl>
    </Modal>
  );
}
